<template>
    <div class="timer">
        {{ formattedTime }}
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, onUnmounted, ref } from 'vue';

    interface Props {
        timeInSeconds: number;
    }

    const props = withDefaults(defineProps<Props>(), {
        timeInSeconds: 300,
    });

    const emit = defineEmits<{
        (e: 'timer:finished'): void;
    }>();

    const delayInSeconds = ref(props.timeInSeconds);
    const remainingSeconds = ref(delayInSeconds.value);
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const formattedTime = computed(() => {
        const hours = Math.floor(remainingSeconds.value / 3600);
        const minutes = Math.floor((remainingSeconds.value % 3600) / 60);
        const seconds = remainingSeconds.value % 60;

        const pad = (n: number) => String(n).padStart(2, '0');

        return `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
    });

    function onCountdownFinished() {
        emit('timer:finished');
    }

    onMounted(() => {
        intervalId = setInterval(() => {
            if (remainingSeconds.value > 0) {
                remainingSeconds.value -= 1;
            } else {
                clearInterval(intervalId!);
                onCountdownFinished();
            }
        }, 1000);
    });

    onUnmounted(() => {
        if (intervalId) {
            clearInterval(intervalId);
        }
    });
</script>

<style scoped lang="scss">
.timer {
    font-size: 16px;
    font-weight: 700;
}
</style>
